export default {
    language: "繁體中文",
    StripeSuccess: {
        loading: "正在處理您的支付...",
        successMessage: "您的訂閱已成功激活！",
        processingError: "支付處理失敗，請聯繫我們",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "郵箱",
            createdAt: "創建時間",
            noRecord: "無記錄",
            loginTime: "登錄時間",
        },
        orders: {
            title: "訂單歷史",
            loading: "加載中...",
            refresh: "刷新",
            orderAmount: "金額",
            points: "積分",
            createdAt: "創建時間",
            orderType: "類型",
            status: "狀態",
            noOrders: "暫無訂單",
            goToSubscription: "前往購買",
            freeCredit: "免費",
            paidCredit: "付費",
            queryOrderFailed: "查詢訂單失敗",
            statusPaid: "已支付",
            statusPending: "待支付",
            statusCancelled: "已取消",
            statusDeactivated: "已失效",
            checkoutUrlNotAvailable: "獲取支付鏈接失敗",
            verifyingPayment: "驗證支付狀態...",
            paymentSuccess: "支付成功",
            paymentPending: "訂單待支付，請完成支付",
            paymentFailed: "支付失敗或已取消",
            paymentStatus: "支付狀態",
            paymentStatusDescription: "您是否已完成支付？",
            cancelPayment: "取消支付",
            completedPayment: "已完成支付",
            warning: "警告",
            confirmCancelOrder: "確定要取消當前訂單嗎？此操作不可撤銷。",
            cancel: "取消",
            confirm: "確認",
            cancellingOrder: "正在取消訂單...",
            orderCancelledSuccess: "訂單已取消",
            cancelOrderFailed: "取消訂單失敗",
            checkOrderStatusFailed: "查詢訂單狀態失敗",
            promptClick: "點擊\"待支付\"狀態可以繼續支付",
        }
    },
    ProductAdv: {
        title: "探索ClixMagicAI的強大功能：",
        advs: [
            {
                title: "AI智能識別引擎：自動定位各類干擾元素",
                desc: "基於深度學習算法，自動識別圖片/視頻中的水印、文字、人臉及複雜背景元素，無需手動標記。支持Instagram、TikTok等平台格式，嚴格保護隱私數據不外洩。",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "去水印"
            },
            {
                title: "圖片淨化大師：秒除Logo/日期戳，畫質無損",
                desc: "精準擦除品牌水印、拍攝日期、貼紙等干擾元素。AI自動修復背景紋理，處理後圖片如原圖般自然，完美適配社交媒體發帖需求。",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "去水印"
            },
            {
                title: "動態水印終結者：抹除滾動字幕/平台Logo",
                desc: "一鍵清除YouTube片尾浮標、TikTok動態水印及滾動字幕。AI智能追蹤逐幀處理，輸出流暢無卡頓的4K高清視頻，支持MP4/MOV等主流格式。",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "去水印"
            }
        ]
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "定價",
            faq: "問題",
        },
        login: "登錄",
        userMenu: {
            account: "管理",
            logout: "登出",
            credit: "積分",
            freeCredit: "免費",
            paidCredit: "已購買",
            nextUpdate: "積分下次更新",
            language: "語言",
            theme: "主題",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    Description:{
        title: "ClixMagicAI",
        desc: "一款專業的AI智能去水印工具，支持一鍵快速處理圖片、視頻中的水印，操作簡單高效，效果自然無痕。",
        fileTypes: {
            image: '圖片去水印',
            pdf: 'PDF去水印',
            video: '視頻去水印'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "每日免費體驗", icon: "fa-gift" },
            { id: "imageTag", text: "圖片水印去除", icon: "fa-image" },
            { id: "videoTag", text: "視頻水印去除", icon: "fa-video" },
            { id: "aiPoweredTag", text: "AI智能處理", icon: "fa-robot" },
            { id: "noRegTag", text: "登錄即用", icon: "fa-user-check" },
        ],
        videoPromt: "即將上線，敬請期待！",
        videoDesc: "我們正在努力開發視頻去水印功能，將為您帶來更強大的體驗。"
    },
    Footer: {
        social: {
            title: "聯繫我們",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "法律條款",
        terms: [
            {
                id: 1,
                title: "隱私政策",
                link: "/privacy"
            },
            {
                id: 2,
                title: "服務條款",
                link: "/terms"
            },
            {
                id: 3,
                title: "Cookie 政策",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI 版權所有。"
    },
    Task: {
        image: {
            imageSupportText: '支持 jpg、jpeg、png、webp、heic、heif 格式，單個文件最大 10MB',
            imageFileTooLarge: '文件大小超過限制（最大 10MB）',
            invalidImageType: '不支持的圖片格式，請上傳JPG、JPEG、PNG、WEBP、HEIC或HEIF格式',
            imageWillCost: '將消耗：1 積分',
            hiecSupportText: 'HEIC/HEIF格式將在提交時自動轉換為PNG格式',
            hiecSuccess: 'HEIC/HEIF格式轉換成功',
            hiecFailed: 'HEIC/HEIF格式轉換失敗',
            processingImageTip: '正在處理您的圖片，請稍候...',
            guide: {
                title: '操作指南',
                step1: '上傳圖片',
                step2: '塗抹水印區域或無需塗抹模型自動識別水印',
                step3: '點擊提交'
            }
        },
        common: {
            remaining: '剩餘積分',
            nextUpdate: '積分下次更新',
            handleError: '處理文件時出錯，請嘗試其他文件',
            uploadFailed: '文件上傳失敗',
            dragText: '拖拽文件到這裡或',
            clickText: '點擊上傳',
            loginRequired: '請先登錄後再上傳文件',
            noRemainingTasks: '你的積分已使用完畢',
            loginNow: '立即登錄',
            upgradeNow: '立即購買積分',
            taskSubmitSuccess: '任務提交成功',
            taskSubmitError: '任務提交失敗',
            taskRetrySuccess: '任務重試提交成功！',
            taskRetryError: '任務重試提交失敗！',
            processing: '處理中',
            submit: '提交',
            waiting: '等待中',
            completed: '已完成',
            failed: '失敗',
            cancelled: '取消',
            url_not_found: '獲取鏈接失敗',
            deleted: '已刪除',
            refreshSuccess: '任務列表已刷新',
            refreshFailed: '刷新任務列表失敗',
            deleteSuccess: '任務刪除成功',
            deleteFailed: '任務刪除失敗',
            waitingForCompletion: '請等待當前任務完成後再重試',
            loadOriginalImageFailed: '加載原圖失敗，請重試',
            downloadFailed: '下載失敗',
            startingDownload: '開始下載...',
            noTasks: '暫無任務',
            refresh: '刷新',
            sort: '排序',
            noFilterTasks: '暫無{filter}任務',
            compare: '查看對比',
            originalImage: '原圖',
            processedImage: '處理後',
            dragToCompare: '👈 左右拖動查看對比 👉',
            cancel: "取消",
            delete: "刪除",
            retry: "重試",
            download: "下載",
            createAt: "創建於",
            expiredAt: "過期於",
        },
        video: {
            videoSupportText: '支持 mp4、mov、avi、mkv 格式，單個文件最大 100MB',
            videoFileTooLarge: '文件大小超過限制（最大 100MB）',
            invalidVideoType: '不支持的視頻格式，請上傳MP4、MOV、AVI或MKV格式',
            videoWillCost: '將消耗：3 積分',
            processingVideoTip: '正在處理您的視頻，請稍候...',
            guide: {
                step1: '上傳視頻',
                step2: '選擇對應的水印類型進行框定水印區域',
                step3: '點擊提交'
            },
            annotationTools: '水印標註工具',
            selectType: '選擇水印類型',
            deleteAnnotation: '刪除標註',
            clearAllAnnotations: '清除所有標註',
            annotationHelp: '標註幫助',
            dragTip: '拖動以繪製水印區域',
            resizeTip: '調整大小以匹配水印',
            moveTip: '可以移動已創建的標註',
            processing: '處理中',
            submit: '提交',
            taskSubmitSuccess: '任務提交成功',
            taskSubmitError: '任務提交失敗',
            retryTaskTip: '重試任務提交成功',
            retryFailed: '重試任務失敗',
            uploadFailed: '上傳失敗',
            staticWatermarkDesc: '適用於固定位置的靜態水印',
            normalWatermarkDesc: '適用於普通的固定水印',
            dynamicWatermarkDesc: '適用於變化的動態水印',
            moveWatermarkDesc: '適用於需要移動的水印'
        },
    },
    Router: {
        home: "首頁",
        terms: "服務條款",
        privacy: "隱私政策",
        cookie: "Cookie政策",
        user: "用戶中心",
    },
    Terms: {
        "tabs": {
            "terms": "服務條款",
            "privacy": "隱私政策",
            "cookies": "Cookie 政策"
        },
        "lastUpdated": "最後更新：2025年05月20日",
        "terms": {
            "sections": [
                {
                    "title": "1. 簡介",
                    "description": "歡迎使用ClixMagicAI。使用我們的服務即表示您同意這些服務條款。請仔細閱讀。"
                },
                {
                    "title": "2. 服務描述",
                    "description": "ClixMagicAI提供AI驅動的工具，用於從圖像、視頻中移除水印。我們的服務適用於以下合法用途：",
                    "items": [
                        "移除您自己內容中的水印",
                        "移除您擁有適當權利修改的內容中的水印",
                        "教育和研究目的"
                    ]
                },
                {
                    "title": "3. 用戶責任",
                    "description": "使用ClixMagicAI，即表示您同意：",
                    "items": [
                        "僅上傳您擁有或有適當權利修改的內容",
                        "不將我們的服務用於任何非法目的或違反任何法律",
                        "不嘗試繞過我們的安全措施或使用限制",
                        "不使用我們的服務侵犯他人的知識產權"
                    ]
                },
                {
                    "title": "4. 賬戶條款",
                    "description": "您可能需要創建一個賬戶才能使用我們服務的某些功能。為了登錄，您可以選擇使用Google或GitHub賬號。您負責：",
                    "items": [
                        "維護您賬戶的安全",
                        "在您賬戶下發生的所有活動",
                        "提供準確的賬戶信息（包括但不限於頭像、郵箱、用戶名和用戶ID）"
                    ]
                },
                {
                    "title": "5. 免費和付費服務",
                    "description": "ClixMagicAI提供免費基礎配額和靈活的積分購買選項，用於訪問我們的去水印功能：",
                    "items": [
                        "基礎配額：每位用戶每天將自動獲得10個免費積分，可用於處理內容",
                        "積分消耗規則：圖片去水印每次消耗1積分，視頻去水印每次消耗3積分",
                        "積分購買：您可以選擇購買積分包以獲得更多使用次數，所有購買的積分永久有效，無過期限制",
                        "退款政策：由於數字服務的即時性和虛擬性，積分一旦購買成功，概不退款"
                    ]
                },
                {
                    "title": "6. 知識產權",
                    "description": "ClixMagicAI服務，包括所有由我們創建的軟件、設計和內容，均為我們的知識產權。未經許可，您不得複製、修改或基於我們的服務創建衍生作品。"
                },
                {
                    "title": "7. 責任限制",
                    "description": "ClixMagicAI\"按原樣\"提供服務，不提供任何形式的保證。我們對因您使用我們的服務而產生的任何損害不承擔責任。"
                },
                {
                    "title": "8. 條款變更",
                    "description": "我們可能隨時修改這些條款。在條款變更後繼續使用ClixMagicAI即表示您接受修訂後的條款。"
                },
                {
                    "title": "9. 終止",
                    "description": "如果我們認為您的行為違反了這些條款或對其他用戶、我們或第三方有害，我們保留立即終止或暫停您訪問我們服務的權利，而無需事先通知。"
                },
                {
                    "title": "10. 適用法律",
                    "description": "這些條款應受我們公司註冊地管轄法律的約束，而不考慮其法律衝突規定。"
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. 簡介",
                    "description": "在ClixMagicAI，我們重視您的隱私並致力於保護您的個人數據。本隱私政策解釋了當您使用我們的網站和服務時，我們如何收集、使用和保護您的信息。通過訪問我們的網站或使用任何服務，即表示您接受本政策所述的數據處理方式。我們遵守適用的數據保護法規。"
                },
                {
                    "title": "2. 我們收集的信息",
                    "description": "我們可能收集以下類型的信息：",
                    "items": [
                        { "bold": "賬戶信息", "text": "通過Google或GitHub登錄時提供的用戶頭像、電子郵件地址、用戶名和用戶ID" },
                        { "bold": "使用數據", "text": "關於您如何使用我們的服務的信息，包括訪問的功能和使用時間" },
                        { "bold": "上傳內容", "text": "您上傳處理的圖像、視頻" },
                        { "bold": "支付信息", "text": "購買訂閱時的支付信息（由Creem/Stripe/PayPal等第三方支付網關安全處理，我們僅保留支付狀態記錄）" },
                        { "bold": "技術數據", "text": "IP地址、瀏覽器類型、設備信息" }
                    ]
                },
                {
                    "title": "3. 我們如何使用您的信息",
                    "description": "我們使用您的信息：",
                    "items": [
                        { "text": "提供、維護和改進我們的服務" },
                        { "text": "處理和完成交易" },
                        { "text": "發送技術通知和支持消息" },
                        { "text": "回應您的評論和問題" },
                        { "text": "分析使用模式以增強用戶體驗，並僅在實現服務目的所需的範圍內處理個人數據" },
                        { "text": "確保個人數據的存儲期限不超過必要時間" },
                        { "text": "防止欺詐或非法活動" }
                    ]
                },
                {
                    "title": "4. 數據安全",
                    "description": "我們實施符合行業標準的安全措施保護您的個人信息：",
                    "items": [
                        { "text": "AES-256加密傳輸和存儲中的文件" },
                        { "text": "敏感數據採用零知識架構處理" },
                        { "text": "每日安全日誌審計和漏洞掃描" },
                        { "text": "員工訪問權限遵循最小特權原則" }
                    ]
                },
                {
                    "title": "5. 數據共享",
                    "description": "我們不出售您的個人信息。我們可能與以下方共享信息：",
                    "items": [
                        { "bold": "服務提供商", "text": "僅限於提供特定服務所必需的數據處理（如CloundFlare雲存儲、Creem/Stripe/PayPal等第三方支付網關），且需簽署數據處理協議" },
                        { "bold": "法律要求", "text": "當收到有效的傳票、法院命令或適用於我們的其他法律程序時" }
                    ]
                },
                {
                    "title": "6. 您的權利",
                    "description": "根據您所在地區的有效法律，您可能享有以下權利：",
                    "items": [
                        { "text": "訪問您的個人數據副本" },
                        { "text": "更正不準確或不完整的信息" },
                        { "text": "刪除數據的權利（'被遺忘權'），除非我們有合法理由保留" },
                        { "text": "反對或限制特定類型的數據處理" },
                        { "text": "數據可移植權，可要求轉移您的數據" }
                    ]
                },
                {
                    "title": "7. 兒童隱私",
                    "description": "我們的服務不面向16歲以下未成年人。根據《通用數據保護條例》(GDPR)第8條，16歲以下兒童的同意必須由父母或監護人作出。如果您知道16歲以下未成年人向我們提供了個人信息，請立即通過clixmagicai@gmail.com聯繫我們。"
                },
                {
                    "title": "8. 本政策的變更",
                    "description": "我們可能會定期更新本隱私政策。我們會通過在此頁面上發布新政策並更新\"最後更新\"日期來通知您任何重大變更。對於重大變更，我們將通過電子郵件或其他顯著的方式通知用戶。"
                },
                {
                    "title": "9. 聯繫我們",
                    "description": "如果您對本隱私政策有任何問題，請通過clixmagicai@gmail.com聯繫我們。如果您認為您的數據被不當處理或有任何疑慮，也歡迎隨時聯繫我們。"
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. 什麼是Cookie",
                    "description": "Cookie是當您訪問網站時放置在您的計算機或移動設備上的小型文本文件。它們允許網站識別您的設備並記住您是否之前訪問過該網站。"
                },
                {
                    "title": "2. 我們如何使用Cookie",
                    "description": "ClixMagicAI使用Cookie用於多種目的：",
                    "items": [
                        { "bold": "必要Cookie", "text": "對於我們網站的基本功能（如會話管理和安全功能）是必需的" },
                        { "bold": "偏好Cookie", "text": "記住您的設置和偏好以增強您的體驗，例如通過Google或GitHub登錄後記住您的頭像、用戶名等信息" },
                        { "bold": "分析Cookie", "text": "通過收集匿名信息幫助我們了解訪問者如何與我們的網站互動" },
                        { "bold": "營銷Cookie", "text": "跟蹤您的瀏覽習慣以提供與您興趣相關的廣告" }
                    ]
                },
                {
                    "title": "3. 我們使用的Cookie類型",
                    "subsection": [
                        {
                            "title": "3.1 必要Cookie",
                            "description": "這些Cookie對網站正常運行是必需的。它們啟用核心功能，如安全、網絡管理和賬戶訪問（包括Google和GitHub登錄）。您可以設置瀏覽器阻止這些Cookie，但網站的某些部分可能無法正常工作。"
                        },
                        {
                            "title": "3.2 性能和分析Cookie",
                            "description": "這些Cookie通過收集匿名信息幫助我們了解訪問者如何與我們的網站互動。我們使用這些數據改進我們的網站和服務。這些Cookie不收集可識別訪問者身份的信息。"
                        },
                        {
                            "title": "3.3 功能Cookie",
                            "description": "這些Cookie允許我們的網站記住您做出的選擇（如語言偏好或登錄狀態），以提供增強的個性化功能，比如記住您通過Google或GitHub登錄的狀態。"
                        },
                        {
                            "title": "3.4 定向和廣告Cookie",
                            "description": "這些Cookie用於向訪問者顯示相關廣告並跟蹤我們廣告活動的效果。請注意，由於我們網站主要依賴於第三方登錄（Google和GitHub），這類Cookie主要用於提升用戶體驗而非直接營銷。"
                        }
                    ]
                },
                {
                    "title": "4. 管理Cookie",
                    "description": "您可以通過多種方式控制和管理Cookie。大多數網絡瀏覽器允許您管理Cookie偏好。您可以：",
                    "items": [
                        { "text": "從您的設備刪除Cookie" },
                        { "text": "通過激活允許您拒絕所有或部分Cookie的瀏覽器設置來阻止Cookie" },
                        { "text": "設置瀏覽器在您收到Cookie時通知您" }
                    ]
                },
                {
                    "title": "5. 第三方Cookie",
                    "description": "某些Cookie是由第三方在我們網站上放置的。這些第三方可能包括分析服務（如Google Analytics）和廣告網絡。由於Cookie的工作方式（Cookie只能由最初設置它們的一方訪問），我們不控制這些第三方Cookie的使用，也無法訪問它們。對於通過Google和GitHub登錄的用戶，我們將確保遵循這些平台的隱私指南處理相關信息。"
                },
                {
                    "title": "6. 本Cookie政策的更新",
                    "description": "我們可能會不時更新本Cookie政策，以反映技術、法規或我們業務實踐的變化。任何變更都將在此頁面上發布，並更新修訂日期。"
                },
                {
                    "title": "7. 聯繫我們",
                    "description": "如果您對我們使用Cookie有任何問題，請通過clixmagicai@gmail.com聯繫我們。"
                }
            ]
        }
    },
    UserFeedback: {
        title: "用戶心聲",
        feedback: "聆聽來自全球創作者與專業人士對我們的AI圖像處理技術的真實評價。",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "林先生",
                profession: "視頻剪輯師 & 自媒體內容創作者",
                rating: 5,
                comment: "太牛了！ClixMagicAI處理速度超快的！上傳帶水印視頻，幾分鐘就能輸出無水印版本，畫質完全沒損失，簡直是去水印必備神器！"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "蘇女士",
                profession: "社交媒體運營專家",
                rating: 5,
                comment: "ClixMagicAI拯救了我的Ins素材庫！複雜水印也能精準識別，邊緣處理比之前用的軟件細膩多了，視覺效果更自然。"
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "陳先生",
                profession: "短視頻內容製作人",
                rating: 5,
                comment: "ClixMagicAI去水印超方便，通勤路上處理TikTok素材，到公司直接下載高清版，效率翻倍！是自媒體工作者的福音。"
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "黃先生",
                profession: "平面設計師 & 視覺創意總監",
                rating: 5,
                comment: "作為設計師我很滿意！處理客戶提供的帶Logo樣圖時，背景紋理修復得很自然，毫無PS痕跡，節省大量後期時間。"
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Emily女士",
                profession: "自由職業數字內容創作者",
                rating: 5,
                comment: "發現寶藏啦！會員價比市面上其他去水印產品便宜很多，但去水印效果反而更好，特別是處理漸變透明水印時優勢明顯。"
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Robertson先生",
                profession: "企業培訓課程製作人",
                rating: 5,
                comment: "ClixMagicAI不用安裝真方便！公司電腦權限限制裝不了軟件，現在用瀏覽器就能處理課程素材，隨時隨地都能用。"
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "周女士",
                profession: "家庭主婦 & 社群圖文編輯者",
                rating: 5,
                comment: "操作界面簡單到姥姥都會用！沒有時間學習PS專業軟件的一定要試一試ClixMagicAI，十分適合我這種技術小白用戶。哈哈~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Johnson先生",
                profession: "電商視覺策劃",
                rating: 5,
                comment: "ClixMagicAI太強大啦，可以去除圖片、視頻、小物件、路人、文字等等，功能全面，推薦給大家~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "方女士",
                profession: "攝影愛好者 & 網絡內容分享者",
                rating: 5,
                comment: "哇~終於找到不破壞畫質的去水印工具了！像魔法一樣神奇~p圖不再是難題！強烈推薦！！！"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Williams先生",
                profession: "在線教育講師",
                rating: 5,
                comment: "水印位置記憶功能超實用！處理系列課程視頻時不用反復框選，節省至少半小時工作量，大大提升我的教學準備效率。"
            }
        ]
    },
    Order: {
        purchasePoints: "購買積分",
        subtitle: "選擇合適的積分套餐，享受高質量的水印去除服務",
        loginReminderDesc: "登錄後即可選擇並購買積分",
        freeTag: "免費",
        freePlan: "免費計劃",
        autoActivated: "登錄後自動激活",
        points: "積分",
        autoIncluded: "免費贈送",
        discount: "優惠",
        purchase: "立即購買",
        paymentStatusDescription: "您是否已完成支付？",
        paymentNotCompleted: "支付未完成",
        queryOrderFailed: "查詢訂單狀態失敗",
        cancelPayment: "取消支付",
        completedPayment: "已完成支付",
        warning: "警告",
        confirmCancelOrder: "確定要取消當前訂單嗎？此操作不可撤銷。",
        cancel: "取消",
        confirm: "確認",
        selectProductFirst: "請先選擇一個套餐",
        creatingOrder: "正在創建訂單...",
        orderCreated: "訂單創建成功",
        createOrderFailed: "創建訂單失敗",
        checkoutUrlNotAvailable: "獲取支付鏈接失敗",
        cancellingOrder: "正在取消訂單...",
        orderCancelledSuccess: "訂單已取消",
        cancelOrderFailed: "取消訂單失敗",
        verifyingPayment: "正在驗證支付狀態...",
        paymentSuccess: "支付成功",
        paymentPending: "訂單待支付，請完成支付",
        paymentFailed: "支付失敗或已取消",
        checkOrderStatusFailed: "查詢訂單狀態失敗",
        quickStart: "快速體驗",
        shortTerm: "短期使用",
        recommended: "推薦",
        bestValue: "最具性價比",
    },
    Login: {
        title: "登錄",
        subtitle: "使用社交賬號快速登錄",
        memberTip: "登錄後可享受更多功能",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "使用 GitHub 賬號登錄"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "使用 Google 賬號登錄"
            }
        ],
        error: {
            serverError: "服務器錯誤，請稍後再試",
            networkError: "網絡錯誤，請檢查網絡連接"
        }
    },
    OAuthCallback: {
        loading: "正在處理登錄請求",
        pleaseWait: "請稍等，正在驗證登錄信息...",
        error: "登錄失敗",
        backToHome: "返回首頁",
        success: "登錄成功",
        redirecting: "正在跳轉到首頁..."
    },
    FAQ: {
        title: "ClixMagicAI 使用指南與常見問題",
        prompt: "遇到任何問題或有任何疑問？隨時聯繫我們：clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "什麼是 ClixMagicAI 以及它是如何工作的？",
                answer: "ClixMagicAI 是一款先進的 AI 驅動的水印去除工具。它支持自動識別圖片和視頻中的水印，並提供手動標註水印位置的功能。對於圖片，支持多種格式轉換並確保高質量輸出；對於視頻，能夠處理靜態、動態甚至形狀變化的水印。"
            },
            {
                id : 2,
                question: "ClixMagicAI 提供免費使用嗎？",
                answer: "是的，我們提供每日10積分的基礎免費服務！您可以用來處理圖片（每次消耗1積分）或影片（每次消耗3積分）。目前暫不支持額外購買積分，僅有每日贈送的10積分。"
            },
            {
                id : 3,
                question: "我可以購買額外的積分嗎？",
                answer: "現階段暫不支持額外購買積分。每位用戶每天僅可獲得10個免費積分，次日自動更新。"
            },
            {
                id : 4,
                question: "支持哪些文件格式？",
                answer: "對於圖片，我們支持PNG、JPEG、JPG、WEBP、HEIC和HEIF格式，其中HEIC和HEIF將自動轉換為PNG。視頻方面，支持包括MP4、MOV在內的多種格式。"
            },
            {
                id : 5,
                question: "如何保護我的隱私？",
                answer: "在ClixMagicAI，我們高度重視用戶隱私。所有上傳的文件都將被加密處理，且在處理完成後的24小時內自動刪除。我們不會保存任何用戶文件或相關信息。"
            },
            {
                id : 6,
                question: "我可以怎樣登錄ClixMagicAI？",
                answer: "我們支持通過GitHub或Google賬號快速登錄，確保您的賬戶安全同時簡化註冊流程。"
            },
            {
                id : 7,
                question: "處理速度有多快？",
                answer: "得益於我們的高性能服務器和優化的AI算法，大多數圖片去水印任務可以在10秒內完成，而視頻去水印則最快僅需1分鐘。實際時間可能會根據文件大小和複雜度有所不同。"
            },
            {
                id : 8,
                question: "處理後的效果如何？",
                answer: "我們的AI模型經過大量訓練，能夠智能地去除圖片和視頻中的水印，同時保持原始內容的質量。無論是自動識別還是手動標註的水印，都能得到有效的去除，確保最終結果自然無痕。"
            },
            {
                id : 9,
                question: "每個任務的有效期是多久？",
                answer: "一旦任務完成，處理後的文件將在ClixMagicAI上保留24小時，以便用戶下載。過期後，文件將自動從我們的服務器中刪除以保護您的隱私。"
            },
            {
                id : 10,
                question: "最大文件大小限制是多少？",
                answer: "我們接受的最大圖片文件大小為10MB，視頻文件最大為100MB。超出此限制的文件可能需要先進行壓縮或裁剪才能上傳。"
            }
        ]
    },
    Recommend:{
        title: "",
        desc: "",
        collapse: "收起",
        expand: "展開",
        products: [
            {
                "title": "",
                "desc": "",
                "image": "",
                "link": ""
            },
        ]
    },
}